import { render } from "./SecondOpinionRequest.vue?vue&type=template&id=577f5a5c&scoped=true&ts=true"
import script from "./SecondOpinionRequest.vue?vue&type=script&lang=ts"
export * from "./SecondOpinionRequest.vue?vue&type=script&lang=ts"

import "./SecondOpinionRequest.vue?vue&type=style&index=0&id=577f5a5c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577f5a5c"]])

export default __exports__